import {environment} from '../../environments/environment';

export const isTenant = (tenant: Tenant) => environment.tenant === tenant;

export enum Tenant {
  WARME_SCHOLEN = 'ws',
  WARME_STEDEN_EN_GEMEENTEN = 'wsg',
  WARM_VLAANDEREN = 'wv',
}
